import axios from 'axios';
import { userEmail } from './auth.js';

let API_URL = '/api';

export const setApiUrl = (url) => {
    API_URL = url;
};

const BASE_HEADERS = {
    'Authorization': 'Basic bG9uZzp6aGFuZzUyMTQ/',
};

function getHeaders(extra = {}) {
    return {
        ...BASE_HEADERS,
        ...extra
    };
}

// --- Auth / User APIs ---

export const sendVerificationCode = async (email) => {
    return axios.post(`${API_URL}/send-code/email`, {email}, {
        headers: getHeaders({
            'Content-Type': 'application/json'
        }),
    });
}

export const loginWithEmail = async (email, verifyCode) => {
    const body = {
        email,
        code: verifyCode
    };
    return axios.post(`${API_URL}/login/email`, body, {
        headers: getHeaders({
            'Content-Type': 'application/json'
        }),
    });
}

export function fetchUserInfo(email) {
    return axios.post(`${API_URL}/user/info`, {email}, {
        headers: getHeaders({
            token: email,
            'Content-Type': 'application/json',
        }),
    });
}

// --- Task / Merge APIs ---

export function mergeTask(page, pageSize, email) {
    let body = {
        page: page,
        page_size: pageSize,
        email: email,
    }
    return axios.post(`${API_URL}/task/merge`, body, {
        headers: getHeaders(),
    });
}

export function downloadTask(email, taskId) {
    return axios.post(`${API_URL}/task/download`, {email, taskId}, {
        headers: getHeaders(),
    });
}

export function sendDownloadLink(email, taskId) {
    return axios.post(`${API_URL}/task/send-download-link`, {email, taskId}, {
        headers: getHeaders(),
    });
}

// --- COS-based APIs ---

// Sign upload batch - get COS upload signature
export const signUploadBatch = async (fileInfos) => {
    const body = {
        files: fileInfos,
    };
    return axios.post(`${API_URL}/sign-upload-batch`, body, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json'
        }),
    });
}

// Submit merge task via COS
export const submitMergeTask = async (signUploadResponse, isRemoveFirstPoint) => {
    return axios.post(`${API_URL}/common/web/cos/merge`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json',
            'remove-first-point': isRemoveFirstPoint ? 'true' : 'false'
        }),
    });
}

// Convert GPX to FIT via COS
export const gpx2fitCos = async (signUploadResponse, sport, distance) => {
    return axios.post(`${API_URL}/common/web/cos/gpx2fit`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json',
            sport,
            distance,
        }),
    });
}

// Convert FIT to GPX via COS
export const fit2GpxCos = async (signUploadResponse) => {
    return axios.post(`${API_URL}/common/web/cos/fit2gpx`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json'
        }),
    });
}

// Convert GPX to KML via COS
export const gpx2kmlCos = async (signUploadResponse) => {
    return axios.post(`${API_URL}/common/web/cos/gpx2kml`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json'
        }),
    });
}

// Convert FIT to KML via COS
export const fit2KmlCos = async (signUploadResponse) => {
    return axios.post(`${API_URL}/common/web/cos/fit2kml`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json'
        }),
    });
}

// Convert KML to GPX via COS
export const kml2GpxCos = async (signUploadResponse) => {
    return axios.post(`${API_URL}/common/web/cos/kml2gpx`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json'
        }),
    });
}

// Remove cadence data via COS
export const removeCadenceCos = async (signUploadResponse, distance) => {
    return axios.post(`${API_URL}/common/web/cos/cadence`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json',
            'distance': distance || ''
        }),
    });
}

// Trim FIT file via COS
export const trimFitCos = async (signUploadResponse) => {
    return axios.post(`${API_URL}/common/web/cos/trim`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json'
        }),
    });
}

// Trim FIT file by end time via COS
export const endTimeTrimFitCos = async (signUploadResponse, endTime, distance) => {
    return axios.post(`${API_URL}/common/web/cos/end_time`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json',
            'end-time': endTime,
            'distance': distance || ''
        }),
    });
}

// Repair FIT file via COS
export const repairFitCos = async (signUploadResponse) => {
    return axios.post(`${API_URL}/common/web/cos/repair`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json'
        }),
    });
}

// Get task statistics
export const getTaskStats = async () => {
    return axios.get(`${API_URL}/basic/task-stats`, {
        headers: getHeaders(),
    });
}

// Submit feedback
export const submitFeedback = async (email, content, type) => {
    return axios.post(`${API_URL}/common/web/feedback`, {email, content, type}, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json'
        }),
    });
}

// Batch convert via COS (zip file upload)
export const batchConvertCos = async (signUploadResponse, targetType, sport, distance) => {
    return axios.post(`${API_URL}/common/web/cos/batch-convert`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json',
            'target-type': targetType,
            sport: sport || '',
            distance: distance || '',
        }),
    });
}

// Analyze track file
export const analyzeTrack = async (signUploadResponse) => {
    return axios.post(`${API_URL}/basic/analyze-track`, signUploadResponse, {
        headers: getHeaders({
            token: userEmail(),
            'Content-Type': 'application/json'
        }),
    });
}
